module.exports = __webpack_public_path__ + "img/40_38_072_620.9e7c544a.jpg";